import DomainEntity from '@/models/DomainEntity'

export default class StateOldContracts extends DomainEntity {
  static get collectionName() {
    return 'stateoldcontracts/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
